import 'modaal';

if (window.$ == null) {
    window.$ = window.jQuery;
}

import PeoplePage from './people';
import FoamPage from './foam';
import HomePage from './home';
import SinaiTabs from './tabs';

$(document).ready(function() {
    var home = new HomePage();
    var people = new PeoplePage();
    var foam = new FoamPage();
    var tabs = new SinaiTabs();
});